export function Email( lg: string ): boolean
{
    let rx = new RegExp( "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$" );
    return rx.test( lg );
}

export function Cuit( cuit: string )
{
    if ( cuit.length != 11 )
    {
        return false;
    }

    let acumulado = 0;
    let digitos: string[] = cuit.split( "" );
    let digito: number = parseInt( digitos.pop() );

    for ( let i = 0; i < digitos.length; i++ )
    {
        acumulado += parseInt( digitos[9 - i]) * ( 2 + ( i % 6 ) );
    }

    let verif = 11 - ( acumulado % 11 );
    if ( verif == 11 )
    {
        verif = 0;
    }

    return digito == verif;
}



